(function() { window.GUID_31f6281b_3bbe_42c3_bf83_deed04445b7e = { getGuid: function() { return "31f6281b-3bbe-42c3-bf83-deed04445b7e"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class ImageCropperPersona {
            static Create(param, extraParam) {
                // TODO :
                //      Définir quelle est la taille par défaut selon le type d'image.
                //      Les tailles ci-dessous sont simplement des suggestions de taille basées sur le format rendu par les "PictureHelper" de persona/event.
                var _a, _b, _c;
                let imageType;
                if (typeof param.ImageType === "string") {
                    imageType = CS.Entity.General.ImageHistoryTypeEnum[param.ImageType];
                }
                else {
                    imageType = param.ImageType;
                }
                switch (imageType) {
                    case CS.Entity.General.ImageHistoryTypeEnum.ProfilPicture:
                        param.CroppingSize = CS.GlobalConst.PictureSizes.PersonOriginalSize;
                        param.DisableMinSizeRestriction = (_a = param.DisableMinSizeRestriction) !== null && _a !== void 0 ? _a : true;
                        //Voir si on affiche l'overlay pour la photo de profil aussi ...
                        break;
                    case CS.Entity.General.ImageHistoryTypeEnum.Person:
                        param.CroppingSize = CS.GlobalConst.PictureSizes.PersonOriginalSize;
                        param.DisableMinSizeRestriction = (_b = param.DisableMinSizeRestriction) !== null && _b !== void 0 ? _b : true;
                        param.ImageOverlayUrl = "/cdn/cs/images/overlay-player.png";
                        param.SaveOverlay = false;
                        break;
                    case CS.Entity.General.ImageHistoryTypeEnum.Team:
                        param.CroppingSize = CS.GlobalConst.PictureSizes.TeamOriginalSize;
                        param.DisableMinSizeRestriction = (_c = param.DisableMinSizeRestriction) !== null && _c !== void 0 ? _c : true;
                        break;
                    case CS.Entity.General.ImageHistoryTypeEnum.SportEvent:
                        param.CroppingSize = CS.GlobalConst.PictureSizes.EventOriginalSize;
                    default:
                        // Si rien n'est fourni, une taille par défaut?
                        break;
                }
                return Controls.ImageCropper.Create(param, extraParam);
            }
        }
        Controls.ImageCropperPersona = ImageCropperPersona;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=image-cropper-persona.js.map
